import React, { useState } from "react"
import axios from "axios";

import Layout from "../components/layout"
import SEO from "../components/seo"

import Talkbox from '../images/talkbox-brandname.svg';
import Enlist from '../images/enlist-brandname.png';
import Teamwork from '../images/teamwork-brandname.png';
import Grick from '../images/grick-brandname.png';
import WorkFromHomeImage from '../images/wfh-image.svg';
import EnrollmentScreenImage from '../images/enrollment-screen-image.png';
import TeamworkScreenImage from '../images/teamwork-screen-image.png';
import GrickScreenImage from '../images/grick-screen-image.png';
import TalkboxAppIcon from '../images/talkbox-icon.png';
import StarRatingImage from '../images/star-rating-image.svg';
import QuoteLeft from '../images/quote-left.svg';
import QuoteRight from '../images/quote-right.svg';
import ContactImage from '../images/contact-image.svg';
import TalkboxTeam from '../images/talkbox-team.png';

import "../styles/global.css"

const IndexPage = () => {
  const [grickPremiumChecked, setGrickPremiumChecked] = useState(false);
  const [contactFormData, setContactFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const setContactFieldValue = (field, value) => {
    setContactFormData(contactFormValue => ({
      ...contactFormValue,
      [field]: value,
    }));
  }

  const handleSubmit = event => {
    setError("");
    event.preventDefault()
    var firstName = contactFormData.firstName;
    var lastName = contactFormData.lastName;
    var email = contactFormData.email;
    var phone = contactFormData.phone;
    var companyName = contactFormData.companyName;
    var message = "D-Biz : " + contactFormData.message;

    if (firstName === "" || lastName === "" || email === "" || phone === "" || companyName === "" || message === "D-Biz") {
      setIsSubmitted(false);
      setError("請填妥所有聯絡資料");
      return;
    }

    axios.post('https://compus.hk/api/requestADemo', {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      companyName: companyName,
      message: message,
    })
      .then(function (response) {
        setIsSubmitted(true);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  return <Layout>
    <SEO title="Home" />
    <div className="container">
      <img className="brandname" src={Talkbox} alt="" />
      <h1 className="cover-punchline cover-background">
        <span className="punchline-spacing">無論
        <span className="highlight-teamwork">對內溝通</span></span>
        <span className="highlight-grick">對外銷售</span><br />
        傳遞訊息順心更稱心
      </h1>
    </div>
    <div className="container">
      <div className="row introduction work-from-home-section reverse">
        <div className="column column-col-6 focus "><img className="support-image" src={WorkFromHomeImage} alt="" /></div>
        <div className="column column-col-6 description">
          <h1>遙距工作一段時間<br />大家工作步伐唔一致？<br />追唔上工作進度？</h1>
          <p>相信不少企業於疫症期間，在留在家中工作上遇到唔少樽頸或阻濟。輕則就影響工作進度，重則就因溝通上同事間沒有共識，影響覆客戶問題唔夠準確同快，就白白錯失獲得生意機會。</p>
          <p>至於我們一直使用 Teamwork 及 Grick，縱使身處家中工作，都仿如置身公司內，與同事溝通合作無間，生意更接踵以來。</p>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row introduction">
        <div className="column-col-6 description">
          <img className="intro-brandname" src={Enlist} alt="" />
          <h2><span className="spacing">付款到報名</span>快夾爽</h2>
          <p>從建立報名表格，到嵌入電子支付都不費吹灰之力<br />即使疫症肆虐，都輕易收取款項亦無阻遙距課程需要。</p>
          <ul>
            <li>支援信用卡及各種電子支付</li>
            <li>可為每個課程配置合作夥伴圖示及海報</li>
            <li>檢視申請者的繳費情況</li>
            <li>讓申請者查詢狀況</li>
            <li>下載每個課程的繳費報告</li>
          </ul>
          <a href="https://enlist.cc/" target="_blank">
            <button className="button-learn-more">了解更多</button>
          </a>
        </div>
        <div className="column-col-6 focus "><img className="support-image" src={EnrollmentScreenImage} alt="" /></div>
      </div>
    </div>
    <div className="container">
      <div className="row introduction reverse">
        <div className="column-col-6 focus "><img className="support-image" src={TeamworkScreenImage} alt="" /></div>
        <div className="column-col-6 description">
          <img className="intro-brandname" src={Teamwork} alt="" />
          <h2><span className="spacing">讓員工之間有所共識</span>減少溝通上困難</h2>
          <p>使用電子郵件與同事內部溝通，遠遠不及使用即時通訊更有效率<br />即可分開公私事宜之外，同事之間在工事上更合作無間</p>
          <ul>
            <li>可為團隊、專案或主題建立溝通群組</li>
            <li>員工之間可發送文字、語音、相片、影片或多種格式文件</li>
            <li>方便人力資源建立公司適用表格</li>
            <li>簡易整理員工名單</li>
            <li>支援 iOS, Android 裝置及網頁使用</li>
          </ul>
          <a href="https://teamworkapp.co/" target="_blank">
            <button className="button-learn-more">了解更多</button>
          </a>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row introduction">
        <div className="column-col-6 description">
          <img className="intro-brandname" src={Grick} alt="" />
          <h2>將 WhatsApp、Facebook Messenger 等的客戶訊息整合，促進銷售及開拓產品支援渠道</h2>
          <p>企業每日需要處理不同客戶需要及疑問，<br />只需要一個平台就整合由不同通訊應用發出的客戶訊息<br />幫你調節不同客戶節奏之餘，促進銷售效果。</p>
          <ul>
            <li>遇到客戶疑問可節省雙方時間</li>
            <li>促進產品銷售體驗</li>
            <li>蒐集客戶對公司服務表現</li>
            <li>建立聊天機器人，提供優越客戶服務體驗</li>
            <li>支援 WhatsApp、Facebook Messenger、Web (SDK) 及 App (SDK)</li>
          </ul>
          <a href="https://grick.io/" target="_blank">
            <button className="button-learn-more">了解更多</button>
          </a>
        </div>
        <div className="column-col-6 focus"><img className="support-image" src={GrickScreenImage} alt="" /></div>
      </div>
    </div>
    <div className="container focus">
      <h2>產品收費</h2>
      <div className="row introduction">
        <div className="column-col-3 card focus story">
          <img className="card-brandname" src={Enlist} alt="" />
          <div className="change-plan-price">
            <span className="dollar-sign">$</span>
            <span className="price">50,000</span>
            <span className="asterisk">*</span> 一次性
              </div>
          <ul>
            <li>建立活動報名表格及讓參加者註冊及報名活動或課程</li>
            <li>收集付款資料從信用卡、預付卡或各種電子支付</li>
            <li>參加者可查詢付款狀態及報名結果</li>
            <li>提供操作界面讓職員概覽所有參加者表格及報名狀態</li>
          </ul>
        </div>
        <div className="column-col-3 card focus story">
          <img className="card-brandname" src={Teamwork} alt="" />
          <div className="change-plan-price">
            <span className="dollar-sign">$</span>
            <span className="price">8,300</span>
            <span className="asterisk">*</span> 每月
              </div>
          <ul>
            <li>提供 300 個用戶授權</li>
            <li>團隊可以而快速及加密傳遞訊息，可跨平台上使用，支援網頁、Android 及 iOS 裝置上使用</li>
            <li>可透過 Blast 傳遞公告訊息給不同組別</li>
            <li>隨意自設公司應用程式的主頁面</li>
            <li>可為人力資源部門製作請假 / 申請索償表格 / 活動參與 / 投選等表格</li>
            <li>透過自動化流程幫助公司制定業務流程</li>
            <li>可靠安全雲端寄存</li>
          </ul>
        </div>
        <div className="column-col-3 card focus story">
          <img className="card-brandname" src={Grick} alt="" />
          <div className="change-plan-price">
            <span className="dollar-sign">$</span>
            <span className="price">{grickPremiumChecked ? "4,800" : "9,600"}</span>
            <span className="asterisk">*</span> 每月
          </div>
          <div className="row toggle-button">
            <p>全面</p>
            <label className="switch">
              <input type="checkbox" checked={grickPremiumChecked} onChange={() => {
                setGrickPremiumChecked(!grickPremiumChecked);
              }} />
              <span className="slider"></span>
            </label>
            <p>基本</p>
          </div>
          <ul>
            <li>{grickPremiumChecked ? "每月只有 2000個 活躍用戶配額" : "無限活躍用戶配額"}</li>
            <li>{grickPremiumChecked ? "可供 3 個管理員使用" : "可供 10 個管理員使用"}</li>
            <li>{grickPremiumChecked ? "提供 WhatsApp Business 號碼" : "提供 WhatsApp Business 號碼"}</li>
            <li>整理所有來自於 WhatsApp、Facebook Messenger、Web (SDK) 及 App (SDK) 的團隊收件箱，可讓客戶服務團隊於平台內集中回應客戶需要及進行銷售</li>
            <li>可建立聊天機器人自動回答客戶常見問題</li>
            <li>為客戶建立簡歷，到訪公司網頁紀錄及用戶標籤於客戶關聯管理系统 (CRM)</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row introduction">
        <div className="vision">
          <h1>Talkbox 自創立以來就籌劃遙距工作可能性</h1>
          <p>我們致力透過通訊應用程式拉近人與人之間距離，促成同事之間良好溝通關係，亦不受時間或地域界限發掘更多生意可能性，多年來一直獲外界垂青。</p>
          <a href="https://talkbox.app/" target="_blank">關於 Talkbox</a>
          <ul>
            <div className="row rating-section">
              <div className="column-col-6 rating-feedback">
                <img className="quote quote-left" src={QuoteLeft} alt="" />
                <img className="rating" src={StarRatingImage} alt="" />
                <li>這個應用程式不俗，而且比其他應用程式更好<br />出色的通知，低數據成本，輕鬆體驗</li>
                <img className="quote quote-right" src={QuoteRight} alt="" />
              </div>
              <div className="column-col-6 rating-feedback">
                <img className="quote quote-left" src={QuoteLeft} alt="" />
                <img className="rating" src={StarRatingImage} alt="" />
                <li>語音訊息細緻清晰<br />訊息傳送可靠而穩妥，冇甩漏</li>
                <img className="quote quote-right" src={QuoteRight} alt="" />
              </div>
            </div>
          </ul>
          <img className="talkbox-team" src={TalkboxTeam} alt="" />
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row introduction">
        <div className="column-col-6 focus "><img className="support-image" src={ContactImage} alt="" /></div>
        <div className="column-col-6 contact-form">
          <h1>歡迎與我們傾傾你的業務需要</h1>
          <p>Talkbox 是合資格的「遙距營商計劃」的企業及服務供應商之一</p>
          <div style={{ display: isSubmitted ? 'none' : 'block' }}>
            <div className="form-group">
              <div className="row">
                <input type="text" name="lastName" value={contactFormData.lastName} onChange={(event) => setContactFieldValue("lastName", event.target.value)} className="form-control column-col-6" placeholder="姓氏" />
                <input type="text" name="firstName" value={contactFormData.firstName} onChange={(event) => setContactFieldValue("firstName", event.target.value)} className="form-control column-col-6" placeholder="名字" />
              </div>
              <input type="text" name="email" value={contactFormData.email} onChange={(event) => setContactFieldValue("email", event.target.value)} className="form-control form-fluid" placeholder="電郵電址" />
              <input type="text" name="phone" value={contactFormData.phone} onChange={(event) => setContactFieldValue("phone", event.target.value)} className="form-control form-fluid" placeholder="聯絡電話" />
              <input type="text" name="companyName" value={contactFormData.companyName} onChange={(event) => setContactFieldValue("companyName", event.target.value)} className="form-control form-fluid" placeholder="公司名稱 (商業登記)" />
              <input type="text" name="message" value={contactFormData.message} onChange={(event) => setContactFieldValue("message", event.target.value)} className="form-control form-fluid" placeholder="簡述公司的業務性質及需要..." />
            </div>
            <div className="error-message" style={{ display: error ? 'block' : 'none' }}>
              <p>{error}</p>
            </div>
            <button type="submit" onClick={handleSubmit} className="form-button form-fluid" style={{ display: isSubmitted ? 'none' : 'block' }}>確定</button>
          </div>
          <div className="form-success" style={{ display: isSubmitted ? 'block' : 'none' }}>
            <p>多謝你，我們會盡快跟你聯絡！</p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
}

export default IndexPage
